import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/blockpage411/app/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/blockpage411/app/components/ThemeProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/blockpage411/components/dashboard/ClosingCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/blockpage411/components/dashboard/ExploreGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/blockpage411/components/dashboard/FeatureActionCards.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/blockpage411/components/dashboard/TrustSignalsRow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/blockpage411/components/hero/Hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/blockpage411/components/metrics/StatsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/blockpage411/components/search/LargeSearchSection.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/blockpage411/node_modules/next/dist/client/image-component.js");
